<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="itemId">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <p class="inventory-action-modal__hint">
                    Оборудование перейдёт в статус «Неисправно».
                    <template v-if="holderName">
                        Ответственный остаётся прежним — <strong>{{ holderName }}</strong
                        >.
                    </template>
                    Отправить его в ремонт можно будет отдельным действием.
                </p>

                <!-- ОПИСАНИЕ ОБЯЗАТЕЛЬНО, как и у ремонта: «неисправно» без указания,
                     что именно, не отвечает ни на один вопрос, ради которого эту запись
                     потом читают. -->
                <ValidationProvider
                    class="active-form__field"
                    name="mark-broken-comment"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label class="active-form__label active-form__label_required" for="mark-broken-comment">
                        Что случилось
                    </label>

                    <VInput
                        id="mark-broken-comment"
                        name="mark-broken-comment"
                        class="active-form__control"
                        placeholder="Например: не включается, треснул экран"
                        :class="{ error: errors[0] }"
                        :disabled="isSaving"
                        v-model="comment"
                    ></VInput>

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <p class="active-form__error inventory-action-modal__error" v-if="error">{{ error }}</p>

                <div class="active-form__actions">
                    <VButton
                        type="button"
                        class="active-form__action button_green-light"
                        :disabled="isSaving"
                        @click="hide"
                    >
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green" :disabled="isSaving">
                        {{ isSaving ? 'Сохраняем…' : 'Пометить неисправным' }}
                    </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../../../js/enums/ModalNames';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import { markInventoryItemBroken } from '../../../../js/inventory-api';
import { errorMessage } from '../../../../js/error';

/**
 * Отметка о неисправности (7-F2C).
 *
 * ОТДЕЛЬНО ОТ РЕМОНТА, И ОКНО ОБ ЭТОМ ГОВОРИТ. «Сломалось» и «увезли в сервис» — разные
 * события и разные дни: технику находят неисправной на месте, а в ремонт она уезжает
 * позже или не уезжает вовсе. Без этой строки человек решит, что отметка и есть отправка.
 *
 * Держатель не меняется, и это тоже сказано: неисправность не означает, что ответственный
 * перестал отвечать за вещь.
 */
@Component({
    components: {
        VInput,
        VButton,
        VModalWrapper,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryItemMarkBrokenModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_ITEM_MARK_BROKEN })
    name;
    @Prop({ type: String, default: 'Отметка о неисправности' })
    defaultTitle;

    itemId = null;
    holderName = '';
    comment = '';
    error = '';
    isSaving = false;

    async submit() {
        if (this.isSaving || !this.itemId) {
            return;
        }

        this.isSaving = true;
        this.error = '';

        try {
            const response = await markInventoryItemBroken(this.itemId, { comment: this.comment });

            this.resolve(response.data);
            this.hide();
        } catch (requestError) {
            this.error = errorMessage(requestError);
        } finally {
            this.isSaving = false;
        }
    }

    beforeOpen(event) {
        const params = event?.params ?? {};

        this.itemId = params.itemId ?? null;
        this.holderName = params.holderName || '';
        this.comment = '';
        this.error = '';
        this.isSaving = false;
    }

    beforeClose() {
        this.itemId = null;
        this.comment = '';
        this.error = '';
    }
}

export default VInventoryItemMarkBrokenModal;
</script>
